import type { FC } from 'react'
import React from 'react'
import { useSelector } from 'react-redux'
import { BubblingTooltip, Button, InjectHtml } from '@/components/ui'
import { isAuthenticated as isUserAuthenticated, isUserAgrarian } from '@/logic/auth/reducer'
import type { RootState } from '@/redux/interfaces'
import { LandingBlockContainer } from '..'
import type { ITrucksLeasingBannerProps } from './interfaces'
import { messages } from './messages'
import './styles.scss'

const mapState = (state: RootState) => ({
  isAgrarian: isUserAgrarian()(state),
  isAuthenticated: isUserAuthenticated()(state),
})

const TrucksLeasingBanner: FC<ITrucksLeasingBannerProps> = ({ onActionClick, blockId, buttonTooltipMessage }) => {
  const { isAgrarian, isAuthenticated } = useSelector(mapState)
  const shouldDisableButton = isAuthenticated && !isAgrarian

  const bannerButton = (
    <Button
      modifiers={['white']}
      className="space-holder-top16-from-sm space-holder-top32-sm trucks-leasing-banner__button"
      onClick={onActionClick}
      isDisabled={Boolean(buttonTooltipMessage) && shouldDisableButton}
    >
      {messages.button}
    </Button>
  )

  return (
    <LandingBlockContainer
      className="page-wrapper_no-mobile"
      titleClassName="space-holder-left24-sm space-holder24-sm space-holder32-from-sm"
      titleId={messages.sectionTitle}
    >
      <div className="color_white page-wrapper trucks-leasing-banner with-blurred-bottom-block with-blurred-bottom-block_visible">
        <h2 className="space-holder8-from-sm space-holder24-sm trucks-leasing-banner__title">
          <span>{messages.title}</span>
        </h2>
        <div className="row row_nowrap-from-sm row-justify_between" id={blockId}>
          <InjectHtml className="trucks-leasing-banner__special-offers-title" TagName="h5" textId={messages.specialOffers} />
          <div>
            <InjectHtml className="space-holder8-sm" TagName="h5" textId={messages.expressTruckProgram.title} />
            <InjectHtml
              className="color_pale-white trucks-leasing-banner__express-truck-program"
              TagName="p"
              textId={messages.expressTruckProgram.text}
            />
          </div>
        </div>
        {buttonTooltipMessage && shouldDisableButton ? (
          <BubblingTooltip content={buttonTooltipMessage}>
            <span className="inline-block space-holder-top16-from-sm space-holder-top32-sm trucks-leasing-banner__button-wrapper">
              {bannerButton}
            </span>
          </BubblingTooltip>
        ) : (
          bannerButton
        )}
      </div>
    </LandingBlockContainer>
  )
}

export default TrucksLeasingBanner
